// extracted by mini-css-extract-plugin
export default {"container":"MenuLayouts_container__0lLF4","closeButtonWrapper":"MenuLayouts_closeButtonWrapper__CIMcf","offcanvasBody":"MenuLayouts_offcanvasBody__s2A7v"};